import { useMutation } from "@tanstack/react-query";
import { postGoogleFormResponse } from "../utils/googleFormPost";
import { Maybe } from "graphql/jsutils/Maybe";

const submitGoogleForm = (
  data: Record<string, string>,
  googleFormId?: Maybe<string> | undefined,
) => {
  if (!googleFormId) {
    throw new Error("No google form id supplied");
  }
  return postGoogleFormResponse(googleFormId, data);
};

export const useContactFormSubmission = (
  googleFormId: Maybe<string> | undefined,
) => {
  const { mutate, isPending, error, isSuccess } = useMutation({
    mutationFn: (data: Record<string, string>) =>
      submitGoogleForm(data, googleFormId),
  });

  return {
    submitGoogleForm: mutate,
    isGoogleFormSubmitting: isPending,
    isGoogleFormSubmissionError: error,
    isGoogleFormSubmissionSuccess: isSuccess,
  };
};
